import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import OrganizationFilter from '../../components/OrganizationFilter';
import OrganizationPicker from '../../components/OrganizationPicker';
import LabeledSelectionCheckbox from '../../components/LabeledSelectionCheckbox';
import { ventrisConfig } from '../../ventris.config';
import { focusFirstInvalidField } from '../../accessibility/focus';

import GroupPageIcon from '../../icons/GroupPageIcon';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import StudentIcon from '../../icons/StudentIcon';
import { getUseCaseTerminology } from '../../useCase';

type ClinicianGroupProps = {
};

let searchDebounce: any = null;

function ClinicianGroup({}: ClinicianGroupProps) {
  const terms = getUseCaseTerminology();
  const routeParams = useParams();
  const [user, setUser] = useState([] as any);
  const [organizations, setOrganizations] = useState([] as any);
  const [students, setStudents] = useState([] as any);
  const [selectedStudent, setSelectedStudent] = useState({} as any);
  const [selectedStudentId, setSelectedStudentId] = useState("" as any);
  const [selectedStudentIds, setSelectedStudentIds] = useState([] as any);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [errorCreate, setErrorCreate] = useState("");
  const [validatedCreate, setValidatedCreate] = useState(false);
  const [groupInfo, setGroupInfo] = useState({} as any);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [grade, setGrade] = useState("");
  const [birthdate, setBirthdate] = useState(Date.now() as any);
  const [organizationId, setOrganizationId] = useState("");
  const [studentCode, setStudentCode] = useState("");

  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [groupFilter, setGroupFilter] = useState("");
  const [archivedFilter, setArchivedFilter] = useState("");
  const [search, setSearch] = useState("");

  const editFormRef = useRef(null as any);
  const createFormRef = useRef(null as any);

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    let currentUser = sessionStorage.getItem("current_user");
    setUser(JSON.parse(currentUser!));
    setOrganizationId(JSON.parse(currentUser!).organization_id);

    if (routeParams.groupId) {
      setGroupFilter(routeParams.groupId);

      let token = sessionStorage.getItem("token");
      fetch(ventrisConfig.url + '/api/group/' + routeParams.groupId, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        if (data.group) {
          setGroupInfo(data.group);
        }
      });
    }
    
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
      loadStudents(1);
    });
  }, []);

  useEffect(() => {
      loadStudents(page);
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, groupFilter, archivedFilter]);
  
  useEffect(() => {
    if (searchDebounce) {
      clearTimeout(searchDebounce);
    }

    searchDebounce = setTimeout(() => {
      setPage(1);
      loadStudents(1);
    }, 500);
  }, [search]);

  const back = () => {
    window.history.back();
  }

  const loadStudents = (page: number) => {
    setTimeout(() => {
      let token = sessionStorage.getItem("token");
      console.log(page);
      
      fetch(ventrisConfig.url + '/api/students?page=' + page + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&group=' + routeParams.groupId + '&archived=' + archivedFilter + '&search=' + search, {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setStudents(data.students);
        setTotalSize(data.total_records);
      });
    },
    100);
  }

  const editStudent = (student: any) => {
    setSelectedStudent(student);
    setSelectedStudentId(student.id);
    setFirstName(student.first_name);
    setLastName(student.last_name);
    setGrade(student.grade);
    setBirthdate(student.birthdate);
    setOrganizationId(student.organization_id);
    setStudentCode(student.student_code);
    setShowEditModal(true);
  }

  const handleEditSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedEdit(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedEdit(true);
        setErrorEdit("");

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/student/' + selectedStudent.id, {
          method: 'put',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            first_name: firstName,
            last_name: lastName,
            grade: grade,
            birthdate: birthdate,
            student_code: studentCode,
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowEditModal(false);
            setPage(1);
            loadStudents(1);
          } else {
            setErrorEdit("An error occured while editing this student. Please try again!");
          }
        });
    }
  };

  const createStudent = () => {
    const defaultOrganizationId = availableManualOrganizations.find((organization: any) => String(organization.id) === String(user.organization_id))?.id
      ?? availableManualOrganizations[0]?.id
      ?? "";
    setSelectedStudent({});
    setSelectedStudentId(-1);
    setFirstName("");
    setLastName("");
    setGrade("PK");
    setBirthdate(Date.now());
    setOrganizationId(defaultOrganizationId);
    setStudentCode("");
    setShowCreateModal(true);
  }

  const handleCreateSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedCreate(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedCreate(true);
        setErrorCreate("");

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/student', {
          method: 'post',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            organization_id: organizationId,
            first_name: firstName,
            last_name: lastName,
            grade: grade,
            birthdate: birthdate,
            student_code: studentCode,
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            setShowCreateModal(false);
            setPage(1);
            loadStudents(1);
          } else {
            setErrorCreate("An error occured while creating this student. Please ensure that you are using a unique student code and try again!");
          }
        });
    }
  };

  const actuallyDeleteStudents = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/student/delete', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        students: selectedStudentIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      fetch(ventrisConfig.url + '/api/students', {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
        }).then(async function (data) {
        setShowDeleteModal(false);
        setShowArchiveModal(false);
        setPage(1);
        loadStudents(1);
      });
    });
  }

  const actuallyArchiveStudents = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/student/' + (archivedFilter === 'true' ? 'unarchive' : 'archive'), {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        students: selectedStudentIds.join("|")
      })
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setShowDeleteModal(false);
      setShowArchiveModal(false);
      setPage(1);
      loadStudents(1);
    });
  }

  const toggleSelectedStudent = (studentId: string | number) => {
    const normalizedId = String(studentId);
    setSelectedStudentIds((prev: any) =>
      prev.includes(normalizedId)
        ? prev.filter((item: any) => item !== normalizedId)
        : [...prev, normalizedId]
    );
  }

  const checkboxFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
    const { selectedStudentIds, toggleSelectedStudent } = formatExtraData;
    return <LabeledSelectionCheckbox
      id={`group-student-select-${row.id}`}
      label={`Select ${row.first_name} ${row.last_name}`}
      checked={selectedStudentIds.includes(String(row.id))}
      onChange={() => toggleSelectedStudent(row.id)}
    />;
  }

  const studentNameFormatter = (cell: any, row: any) => {
    return (
      <div>
        <span aria-hidden="true" className={row.archived ? "ventris-table-status-archived" : "ventris-table-status-completed"}></span>
        <span className="visually-hidden">{row.archived ? "Archived: " : "Active: "}</span>
        {cell}
      </div>
    );
  }

  const actionFormatter = (cell: any, row: any) => {
    return (
      <div>
        <Button variant="link" size="sm" onClick={() => editStudent(row)} disabled={!!row.schoolday_managed}>Edit</Button>
      </div>
    );
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Select',
      headerFormatter: () => <span className="visually-hidden">Select students</span>,
      formatter: checkboxFormatter,
      formatExtraData: { selectedStudentIds, toggleSelectedStudent }
    },
    {
      dataField: 'student_code',
      text: `${terms.student} Code`,
      sort: true,
      formatter: studentNameFormatter
    },
    {
      dataField: 'last_name',
      text: 'Last Name',
      sort: true
    },
    {
      dataField: 'first_name',
      text: 'First Name',
      sort: true
    },
    {
      dataField: 'grade',
      text: 'Grade',
      sort: true
    },
    {
      dataField: 'birthdate',
      text: 'Birthdate',
      sort: true
    },
    {
      dataField: 'organization',
      text: 'Organization',
      sort: true
    },
    {
      dataField: 'id',
      text: 'Action',
      formatter: actionFormatter
    }
  ];

  const handleTabChange = (tabKey: string | null) => {
    if (tabKey === 'view-all') {
      setArchivedFilter("");
    } else if (tabKey === 'active') {
      setArchivedFilter("false");
    } else if (tabKey === 'archived') {
      setArchivedFilter("true");
    }
    setPage(1);
  }

  const updateFilter = (organizations: any) => {
    setOrganizationFilter(organizations.join('|'));
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setPage(page);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  const availableManualOrganizations = organizations.filter((organization: any) => !organization.schoolday_managed);
  const selectedManagedStudents = students.filter((student: any) => selectedStudentIds.includes(String(student.id)) && student.schoolday_managed);
  const hasSelectedManagedStudents = selectedManagedStudents.length > 0;

  return (
    <Container fluid className="ventris-content-wrapper ventris-students">
      <Header portal={sessionStorage.getItem("portal")!} page="groups" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <h1 className="page-header-no-margin align-items-center">
              <GroupPageIcon />
              <div className="flex-grow">{groupInfo?.name}</div>
              <Form.Control type="search" className="ventris-search" aria-label={`Search ${terms.students.toLowerCase()}`} placeholder={`Search ${terms.students.toLowerCase()}`} value={search} onChange={(event) => setSearch(event.target.value)} />
            </h1>
            <Button variant="link" size="sm" className="back-link" onClick={() => back()}>&#x276E; Back to Groups</Button>
            <h3>Group Info</h3>
            <br />
            <ResponsiveTableRegion label="Group information" className="ventris-groups">
              <div className="react-bootstrap-table react-bootstrap-table-rounded">
                <table className="table tabled-bordered">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Group Name</th>
                      <th>Date Added</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>{groupInfo?.name}</td>
                      <td>{(new Date(Date.parse(groupInfo?.created_at))).toLocaleDateString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ResponsiveTableRegion>
            <br />
            <h3>Group {terms.students}</h3>
            <div className={showFilters ? '' : 'hidden'}>
              <OrganizationFilter updateFilter={updateFilter} organizations={organizations} />
            </div>
            <br />
            <div className="flex flex-row">
              <div className="flex-grow">
                <Tabs defaultActiveKey="view-all" onSelect={(event) => handleTabChange(event)}>
                  <Tab eventKey="view-all" title="View All">
                  </Tab>
                  <Tab eventKey="active" title="Active">
                  </Tab>
                  <Tab eventKey="archived" title="Archived">
                  </Tab>
                </Tabs>
              </div>
              <div className="ventris-action-links">
                <Button variant="link" size="sm" className="ventris-action-link hidden" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowArchiveModal(true)}><ArchiveIcon /> {archivedFilter === 'true' ? 'Unarchive' : 'Archive'} Selected</Button>
                <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowDeleteModal(true)} disabled={hasSelectedManagedStudents}><DeleteIcon /> Delete Selected</Button>
              </div>
            </div>
            {hasSelectedManagedStudents ? <div className="mb-2 text-muted">Selected students in SchoolDay-managed organizations cannot be deleted manually.</div> : null}
            <ResponsiveTableRegion label={`Group ${terms.students}`}>
              <BootstrapTable keyField='id' data={students} columns={columns} bordered={true} remote={{pagination: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} />
            </ResponsiveTableRegion>
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these item(s)? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => actuallyArchiveStudents()}>No, Archive Instead</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteStudents()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showArchiveModal} onHide={() => setShowArchiveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to {archivedFilter === 'true' ? 'unarchive' : 'archive'} these item(s)?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowArchiveModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyArchiveStudents()}>Yes, Confirm {archivedFilter === 'true' ? 'Unarchive' : 'Archive'}</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showEditModal} onHide={() => setShowEditModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="group-edit-student-title">
          <Offcanvas.Header className="offcanvas-header-purple" closeButton>
              <Offcanvas.Title id="group-edit-student-title">Edit {terms.student}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-student-form" validated={validatedEdit} ref={editFormRef} onSubmit={handleEditSubmit}>
                {errorEdit != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorEdit}
                </div> : null}
                <Form.Group className="mb-3" controlId="group-edit-student-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={availableManualOrganizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-edit-student-first-name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="given-name" placeholder="First Name" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-edit-student-last-name">
                    <Form.Label>Last Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="family-name" placeholder="Last Name" value={lastName} onChange={(event) => setLastName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-edit-student-grade">
                    <Form.Label>Grade:</Form.Label>
                    <Form.Select required aria-label="Grade" value={grade} onChange={(event) => setGrade(event.target.value)}>
                      <option value="PK">PK</option>
                      <option value="K">K</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                      <option value="4th">4th</option>
                      <option value="5th">5th</option>
                      <option value="6th">6th</option>
                      <option value="7th">7th</option>
                      <option value="8th">8th</option>
                      <option value="9th">9th</option>
                      <option value="10th">10th</option>
                      <option value="11th">11th</option>
                      <option value="12th">12th</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-edit-student-birthdate">
                    <Form.Label>Birthdate:</Form.Label>
                    <Form.Control required type="date" placeholder="Birthdate" value={birthdate} onChange={(event) => setBirthdate(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a birthdate.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-edit-student-code">
                    <Form.Label>{terms.student} Code:</Form.Label>
                    <Form.Control required type="text" placeholder={`${terms.student} Code`} value={studentCode} onChange={(event) => setStudentCode(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a student code.</Form.Control.Feedback>
                </Form.Group>
                <br /><br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Save</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showCreateModal} onHide={() => setShowCreateModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="group-create-student-title">
          <Offcanvas.Header className="offcanvas-header-purple" closeButton>
              <Offcanvas.Title id="group-create-student-title">Create {terms.student}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-student-form" validated={validatedCreate} ref={createFormRef} onSubmit={handleCreateSubmit}>
                {errorCreate != "" ?
                <div role="alert" className="ventris-form-error">
                  {errorCreate}
                </div> : null}
                <Form.Group className="mb-3" controlId="group-create-student-organization">
                    <Form.Label>Organization:</Form.Label>
                    <OrganizationPicker
                      organizations={availableManualOrganizations}
                      value={organizationId}
                      onChange={setOrganizationId}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-create-student-first-name">
                    <Form.Label>First Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="given-name" placeholder="First Name" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a first name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-create-student-last-name">
                    <Form.Label>Last Name:</Form.Label>
                    <Form.Control required type="text" autoComplete="family-name" placeholder="Last Name" value={lastName} onChange={(event) => setLastName(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a last name.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-create-student-grade">
                    <Form.Label>Grade:</Form.Label>
                    <Form.Select required aria-label="Grade" value={grade} onChange={(event) => setGrade(event.target.value)}>
                      <option value="PK">PK</option>
                      <option value="K">K</option>
                      <option value="1st">1st</option>
                      <option value="2nd">2nd</option>
                      <option value="3rd">3rd</option>
                      <option value="4th">4th</option>
                      <option value="5th">5th</option>
                      <option value="6th">6th</option>
                      <option value="7th">7th</option>
                      <option value="8th">8th</option>
                      <option value="9th">9th</option>
                      <option value="10th">10th</option>
                      <option value="11th">11th</option>
                      <option value="12th">12th</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-create-student-birthdate">
                    <Form.Label>Birthdate:</Form.Label>
                    <Form.Control required type="date" placeholder="Birthdate" value={birthdate} onChange={(event) => setBirthdate(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a birthdate.</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="group-create-student-code">
                    <Form.Label>{terms.student} Code:</Form.Label>
                    <Form.Control required type="text" placeholder={`${terms.student} Code`} value={studentCode} onChange={(event) => setStudentCode(event.target.value)} />
                    <Form.Control.Feedback type="invalid">Please enter a student code.</Form.Control.Feedback>
                </Form.Group>
                <br /><br />
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width">Save</Button>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default ClinicianGroup;
